import React from "react";
import SightlineVerifier from "src/components/sightlineVerifier/sightlineVerifier";
import SightlineVerifierLayout from "src/components/sightlineVerifier/sightlineVerifier-layout";
import { useEffect } from "react";
import { useModelViewerStore } from "@/store/modelViewerStore";
import { SightlineVerifierResponse, SightlineVerifierItem } from "@/types/sightlineVerifier";
import { useSearchParams } from "react-router-dom";
import { getRoute } from "@/api/dwm_api";

const SightlineVerifierPage: React.FC = () => {
  const setSightlineVerifierData = useModelViewerStore(
    (state) => state.setSightlineVerifierData,
  );
  const [searchParams] = useSearchParams();
  const token = searchParams.get("t");

  useEffect(() => {
    console.log("SightlineVerifierPage token", token);
    handleFindSightLinePath();
  }, [token])

  // useEffect(() => {
  //   //TODO SightlineVerifier data
  //   const tempSightlineVerifierData: SightlineVerifierResponse = [{
  //     venueId: "20a3c69e-cac6-4409-b162-33f988b6b549",
  //     levelId: "5af5c7ac-0c7d-4806-8678-0ce75585d407",
  //     from: {
  //       lat: 22.27939295,
  //       lng: 114.16513227,
  //       height: "top",
  //     },
  //     fromName: "fromName",
  //     fromPoiId: "fromPoiId",
  //     to: {
  //       lat: 22.27937643,
  //       lng: 114.16520927,
  //       height: "bottom",
  //     },
  //     toName: "toName",
  //     toPoiId: "toPoiId"
  //   }];
  //   setSightlineVerifierData(tempSightlineVerifierData);
  // }, []);

  const handleFindSightLinePath = async () => {
    if (!token) return;

    try {
      const res = await getRoute(token);
      console.log("getRoute res", res);
      if (isSightlineResponse(res.data)) {
        setSightlineVerifierData(res.data);
      }
    } catch (e) {
      console.error("error when retrieving shared path", e);
    }
  };

  const isSightlineResponse = (data: any): data is SightlineVerifierResponse => {
    return Array.isArray(data) && data.length > 0 && !!(data[0]?.venueId && data[0]?.levelId && data[0]?.from && data[0]?.to);
  };

  return (
    <SightlineVerifierLayout
      children={<SightlineVerifier />}
    ></SightlineVerifierLayout>
  );
};

export default SightlineVerifierPage;
